<template>
    <div id="power-data" class="row-center" v-if="reFresh">
        <template v-if="$route.params.name == 'CapacitanceCompensation'">
            <CapacitanceCompensation />
        </template>
        <template v-else>
            <div class="left column-center">
                <area-details v-if="allArea[details]" width="180" :details="allArea[details]"
                    @click.native.stop="listShow = !listShow"></area-details>
                <div class="list">
                    <div class="search">
                        <input type="text" v-model="filterText" placeholder="请输入关键字" />
                        <img src="../../assets/img/search.png" alt="" />
                    </div>
                    <div class="tree" id="index-tree">
                        <el-scrollbar style="height:100%">
                            <el-tree check-strictly v-if="routeName === 'CircuitBreakerAging'"
                                :render-content="renderContent" check-on-click-node :expand-on-click-node="false"
                                default-expand-all @check="currentChange" :show-checkbox="showCheckBox" node-key="id"
                                @node-click="nodeClick" ref="tree" :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked">
                            </el-tree>
                            <el-tree :expand-on-click-node="false" check-strictly v-else-if="routeName === 'PowerData'"
                                check-on-click-node default-expand-all @check="currentChange"
                                :show-checkbox="showCheckBox" node-key="id" @node-click="nodeClick" ref="tree"
                                :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked">
                                <span v-if="$store.state.project.currentProject.projectId == 4"
                                    slot-scope="{ node, data }" class="power-data-item"
                                    :title="data.label.replace(/[^\x00-\xff]/g, 'AA').length>26?data.label:''">
                                    <div slot="reference">
                                        <span :class="[
                                            'power-data-item-label',
                                            { checked: data.loopId === currentLoop.loopId },
                                        ]" style="width:220rem">{{ node.label }}
                                        </span>
                                        <span class="power-data-item-close"
                                            v-if=" getLoopLTStatus(data) =='True' || Number(getLoopLTStatus(data)) > 0">合闸</span>
                                        <span
                                            v-else-if="getLoopLTStatus(data) == 'False' || Number(getLoopLTStatus(data)) <= 0"
                                            class="power-data-item-open">分闸</span>
                                        <span style="color: #666; margin-right: 10rem" v-else
                                            class="power-data-item1">--</span>
                                    </div>
                                </span>
                                <!-- v-if="routeName === 'PowerData'" -->
                                <span v-else slot-scope="{ node, data }" class="power-data-item"
                                    :title="data.label.replace(/[^\x00-\xff]/g, 'AA').length>26?data.label:''">
                                    <div slot="reference">
                                        <span :class="[
                                            'power-data-item-label',
                                            { checked: data.loopId === currentLoop.loopId },
                                        ]" style="width:220rem">{{ node.label }}
                                        </span>
                                       <span v-if="$store.state.project.currentProject.projectId != 5">
                                            <span class="power-data-item1" v-if="getLoopStatus(data) == undefined"
                                                style="color: #666; margin-right: 10rem">--</span>
                                            <span v-else-if="getLoopStatus(data) == 0 || getLoopStatus(data) == 'False'"
                                                class="power-data-item-open">分闸</span>
                                            <span v-else class="power-data-item-close">合闸</span>
                                       </span>
                                    </div>
                                </span>
                            </el-tree>
                            <el-tree :expand-on-click-node="false" check-strictly v-else-if="routeName === 'protect1'"
                                check-on-click-node default-expand-all @check="currentChange"
                                :show-checkbox="showCheckBox" node-key="id" @node-click="nodeClick" ref="tree"
                                :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked">
                                <!-- <span slot-scope="{ node, data }" class="power-data-item">
                <span :class="[
                    'power-data-item-label',
                    { checked: data.loopId === currentLoop.loopId },
                  ]">{{ node.label }}</span>
              </span> -->
                                <span v-if="routeName === 'protect1'" slot-scope="{ node, data }"
                                    class="power-data-item"
                                    :title="data.label.replace(/[^\x00-\xff]/g, 'AA').length>26?data.label:''">
                                    <span :class="[
                                        'power-data-item-label',
                                        { checked: data.loopId === currentLoop.loopId },
                                    ]">{{ node.label }}</span>
                                    <span v-if="typeof getLoopStatus1(data) === 'undefined'"
                                        style="color: #666; margin-right: 10rem">--</span>
                                    <span v-else-if="getLoopStatus1(data)==0" class="power-data-item-open">运行</span>
                                    <span v-else class="power-data-item-close">故障</span>
                                </span>
                            </el-tree>
                            <el-tree :expand-on-click-node="false" check-strictly v-else check-on-click-node
                                default-expand-all @check="currentChange" :show-checkbox="showCheckBox" node-key="id"
                                @node-click="nodeClick" ref="tree" :data="treeData" :filter-node-method="filterNode" :default-checked-keys="defaultchecked">
                                <span slot-scope="{ node, data }" class="power-data-item"
                                    :title="data.label.replace(/[^\x00-\xff]/g, 'AA').length>22?data.label:''">
                                    <span :class="[
                                        'power-data-item-label',
                                        { checked: data.loopId === currentLoop.loopId },
                                    ]" >
                                        <span slot="reference"> {{ node.label }}</span>
                                        <span v-if="getLoopStatus(data)"></span>
                                    </span>
                                </span>
                            </el-tree>
                        </el-scrollbar>
                    </div>
                </div>
            </div>
            <div class="data">
                <!-- 黎威更改断路器监测，把没有数据的页面显示出来 -->
                <div v-if="treeData.length === 0" class="no-found-data-warpper">
                    <img :src="require('../../assets/img/not_found_data.png')" alt="" />
                </div>
                <!-- v-if="currentLoop" -->
                <component v-else-if="currentLoop" :selectedLoops="checkedLoops" :currentLoop="currentLoop"
                    :is="componentName" />
                <div @click.stop="" class="area-list column-center" style="justify-content: flex-start"
                    v-show="listShow">
                    <div class="search row-center">
                        <input type="text" placeholder="请输入关键词" v-model="areaFilterText" />
                        <img src="../../assets/img/search.png" alt="" />
                    </div>
                    <div class="areas">
                        <template v-if="showAreaNumber === 0">
                            <span style="color: #8c939d; font-size: 18rem">暂无数据</span>
                        </template>
                        <template v-else v-for="(item, index) in allArea">
                            <div class="row row-center" style="justify-content: space-between; cursor: pointer"
                                :key="index" v-if="areaFilter(item)"
                                @click.stop="(details = index), (listShow = false)">
                                <img :src="item.areaImg" alt="" />
                                <p>{{ item.areaName }}</p>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import AreaDetails from "../../components/home/AreaDetails";
    import PowerData from "./PowerData";
    import CircuitBreakerAging from "./CircuitBreakerAging";
    import CapacitanceCompensation from "./CapacitanceCompensation";
    import {
        GET_AREAS,
        GET_AREA_LOOPS,
        transformerList,
        breakerList,
        Arcprotection,
        harmonicAnalysis,
    } from "../../api/power";

    import {
        subscribe,
        unsubscribe,
        subscribeByNodes
    } from "../../mqtt/index";
    import {
        subscribe as alarmSubscribe,
        unsubscribe as alarmUnsubscribe,
    } from "../../mqtt/alarm";
    export default {
        name: "PowerDataHome",
        components: {
            AreaDetails,
            PowerData,
            CircuitBreakerAging,
            CapacitanceCompensation,
        },
        data() {
            return {
                selectedNodes: [],
                showAreaNumber: 0,
                reFresh: true,
                checkedLoops: [],
                currentLoop: null,
                filterText: "",
                listShow: false,
                details: -1,
                areaFilterText: "",
                allArea: [],
                loops: [],
                transformerList: [],
                breakerList: [],
                protect: [],
                Power: [],
                defaultchecked:[0]
            };
        },

        computed: {

            tag() {
                return this.$route.params.tag;
            },
            routeName() {
                return this.$route.params.name;
            },
            showCheckBox() {
                return !(
                    this.tag === "Range" ||
                    this.routeName === "PowerData" ||
                    this.routeName === "Transformer" ||
                    this.routeName === "Breaker" ||
                    this.routeName === "PowerQuality" ||
                    this.routeName === "protect1"
                );
            },
            componentName() {
                switch (this.$route.params.name) {
                    case "PowerData":
                    case "Extremum":
                    case "Running":
                    case "Transformer":
                    case "Breaker":
                    case "PowerTime":
                    case "CircuitBreakerAging":
                    case "PowerQuality":
                    case "protect1":
                        return "PowerData";
                }
            },
            master() {
                if (!this.allArea[this.details]) {
                    return;
                }
                let areaId = this.allArea[this.details].areaId;
                // let master = this.loops.filter((e,i) => e.masterAreaId === areaId);
                return this.loops[0];
            },
            powerDataTree() {
                if (!this.allArea[this.details] || this.loops.length === 0) {
                    return;
                }
                let areaId = this.allArea[this.details].areaId;

                this.loops = this.loops.filter(
                    (l) => l.loopName.indexOf("电容补偿") === -1
                );
                let master = this.loops.filter((loop) => loop.loopType === "IN");
                if(this.$store.state.project.currentProject.projectId == 5){
                    master = this.loops.filter((loop) => loop.loopType === "IN"||loop.loopType === "GTI");
                }
                if (!master) {
                    return this.loops.map((item, index) => {
                        item.label = item.loopName;
                        item.id = index;
                    });
                }
                // 存在进线
                let loopMap = {};
                // 将master的loopId作为key, 放入loopMap, value初始为[];
                master.forEach((item) => (loopMap[item.loopId] = []));
                // 遍历loops, 将所有OUT回路以pid(父级回路id)放入loopMap中的对应数组中
                // console.log(this.loops)
                this.loops.forEach((loop, index) => {
                    loop.label = loop.loopName;
                    loop.id = index;
                    if(this.$store.state.project.currentProject.projectId == 5){
                       if (loop.loopType === "OUT"||loop.loopType === "GTO") {
                            if (this.routeName == "Extremum" || this.routeName == "Running") {
                                //报表管理不加电容补偿

                                if (loop.loopName.indexOf("电容补偿") == -1) {
                                    if (loopMap[loop.pid]) {
                                        loopMap[loop.pid].push(loop);
                                    }
                                }
                            } else {
                                if (loopMap[loop.pid]) {
                                    loopMap[loop.pid].push(loop)
                                }
                            }

                            // console.log(1)
                        }
                    }else{
                        if (loop.loopType === "OUT") {
                            if (this.routeName == "Extremum" || this.routeName == "Running") {
                                //报表管理不加电容补偿

                                if (loop.loopName.indexOf("电容补偿") == -1) {
                                    if (loopMap[loop.pid]) {
                                        loopMap[loop.pid].push(loop);
                                    }
                                }
                            } else {
                                if (loopMap[loop.pid]) {
                                    loopMap[loop.pid].push(loop)
                                }
                            }

                            // console.log(1)
                        }
                    }
                    
                });
                master.forEach((item) => {
                    item.children = loopMap[item.loopId];
                });
                //  { //高压进线
                // if (this.$route.params.name == "PowerData") {
                //   this.loops.forEach((item) => {
                //     if (item.loopType == "GTO") {
                //       master.push(item);
                //     }
                //   });
                // }}
                return master;

                // let other = this.loops.filter(e => e.masterAreaId !== areaId)
                // let masterList = this.loops.filter(e => e.masterAreaId === areaId)
                // // let master = masterList[0] || this.master
                // console.log('========================>', other, masterList, master);

                // if (!master) {
                // 	return
                // }
                // let i = 0
                // return masterList.map(master => {
                // 	master.label = master.loopName
                // 	master.id = i++
                // 	master.children = other.map(e => {
                // 		e.label = e.loopName
                // 		e.id = i++
                // 		return e
                // 	})

                // 	return master
                // })
            },
            treeData() {
                switch (this.$route.params.name) {
                    case "PowerData":

                    case "Extremum":
                    case "Running":
                        this.currentLoop = this.master;
                        if(this.master!=undefined){
                            this.checkedLoops = [this.master]
                            this.defaultchecked = [this.powerDataTree[0].id]
                        }
                        console.log(this.powerDataTree)
                        return this.powerDataTree;
                    case "Transformer":
                        if (this.$store.state.project.currentProject.projectId == 1) {
                            let arr = [{
                                aid: 21,
                                area_id: 21,
                                deviceName: "模拟变压器",
                                device_brand_id: 6,
                                device_category_id: 1,
                                device_class_id: 1,
                                device_details: "{\r\n    \"电气\": {\r\n        \"额定电压\": \"10/0.4kV\",\r\n        \"额定频率\": \"50Hz\",\r\n        \"容量\": \"630kVA\",\r\n        \"低压电压\":\"400V\",\r\n        \"低压电流\":\"909.4A\"\r\n    },\r\n    \"设备结构\": {\r\n        \"防护等级\": \"IP20\"\r\n    },\r\n    \"其他\": {\r\n        \"购买时间\": \"2021-03-01\"}}",
                                device_id: 59,
                                device_img: "http://local.vrmaker.vip:38080/deviceImg/lcy/lcy_dry-type-transformer1.png",
                                device_model_id: 14,
                                device_name: "模拟变压器",
                                device_size: "--",
                                device_svg: "http://local.vrmaker.vip:38080/wiring/lcy-byq1.html",
                                device_type_id: 1,
                                harmonic: false,
                                is_virtual: false,
                                label: "模拟变压器",
                                loopId: 200,
                                loopName: "模拟变压器",
                                loop_id: 200,
                                loop_name: "模拟变压器",
                                loop_type: "TRANSFORMER",
                                loop_url: "B06EBF2CBC4C/T1/Transformer",
                                model_id: "70342478",
                                pid: 111,
                                project_id: 3,
                                sensorLoopId: 202,
                                sid: 2,
                                subLoopUrl: "T1/Transformer",
                            }];
                            this.currentLoop = arr[0];
                            return arr;
                        } else {
                            let transformers = this.transformerList.map((d) => {
                                d.label = d.deviceName;
                                // console.log(d)
                                return d;
                            });
                            this.currentLoop = transformers[0];
                            // console.log(transformers);
                            return transformers;
                        }
                        case "Breaker":
                            // console.log(this.breakerList);
                            let breaker = this.breakerList.map((d) => {
                                d.label = d.loopName;
                                // console.log(d);
                                return d;
                            });
                            this.currentLoop = breaker[0];
                            //留创园断路器监测假数据接上让图标不显示空数据------黎威
                            if (this.$store.state.project.currentProject.projectId == 3) {
                                var air = [];
                                this.currentLoop = air;
                                breaker = air;
                                return breaker;
                            }
                            // console.log(this.breakerList)
                            return this.breakerList;
                        case "CircuitBreakerAging":
                            let breakers = [];
                            this.currentLoop = breakers[0];
                            return this.breakerList;
                        case "protect1":

                            var proJack = this.protect.map((d) => {
                                d.label = d.loopName;
                                return d;
                            });
                            this.$store.commit("ArcprotectStatus", proJack[0]);
                            // console.log(proJack);
                            this.currentLoop = proJack[0];
                            return this.protect;
                        case "PowerQuality":
                            // console.log(this.Power)
                            var Pro = this.Power.filter((d) => {
                                if (d.harmonic == 1) {
                                    d.label = d.loopName;
                                    return d;
                                }
                            });
                            //   console.log(Pro);
                            this.$store.commit("ArcprotectStatus", Pro[0]);
                            this.currentLoop = Pro[0];
                            return Pro;
                }
            },
            //判断项目3合分闸
            getLoopStatus(tpl) {
                //修改回路mqtt实时接收
                return function (value) {
                    subscribe([value.subLoopUrl]);
                    alarmSubscribe([value]);
                    return this.$store.getters.mqttVal(value.subLoopUrl + "/SwitchOn");
                };
            },
            //项目4弧光保护
            getLoopStatus1(tpl) {
                //修改回路mqtt实时接收
                return function (value) {
                    subscribe([value.subLoopUrl])
                    return this.$store.getters.mqttVal(
                        value.subLoopUrl + "/total_status"
                    );
                };
            },
            getBreakerStatus(tpl) {
                //修改回路mqtt实时接收
                return function (value) {
                    subscribe([value.subLoopUrl]);
                    alarmSubscribe([value]);
                    return this.$store.getters.mqttVal(value.subLoopUrl + "/Switch_on_MT");
                };
            },
            //判断项目4合分闸
            getLoopLTStatus(tpl) {
                //修改回路mqtt实时接收
                return function (value) {
                    if (value.switchStatus) {
                        //   console.log(value.switchStatus);
                        subscribe([value.switchStatus]);
                        //   console.log(this.$store.getters.mqttVal(value.switchStatus));
                        return this.$store.getters.mqttVal(value.switchStatus);
                    } else {
                        value.switchStatus = "";
                        subscribe([value.switchStatus]);
                        return this.$store.getters.mqttVal(value.switchStatus);
                    }
                };
            },
        },
        mounted() {
            // console.log(this.$store.getters.mqttVal("T1/1AA5/SwitchOn01/Switch_status_1"))
            GET_AREAS().then((res) => {
                this.allArea = res.data.data.areas;
                this.details = 0;
                this.showAreaNumber = res.data.data.areas.length;
                //   console.log(this.details);
                this.getBreakerList(this.details);
                this.getProtect(this.details);
                this.getPower();
                this.getTransformerList(this.details);
            });
            document.onclick = () => {
                this.listShow = false;
            };
            subscribeByNodes(["SwitchOn"]);
            subscribeByNodes(["Switch_on_MT"]); //分合状态
            // subscribe(["T1/KC_Mic1"]);
            this.loopInit();
        },
        // updated() {
        //   // console.log(this.$store.getters.mqttVal("T2/KC_Mic2/P"));
        // },
        methods: {
            mouseenter(data) {
                this.$set(data, "show", true);
            },
            mouseleave(data) {
                this.$set(data, "show", false);
            },
            loopInit() {
                //let first = this.treeData[0];
                //this.$refs.tree.setCheckedNodes([first])
                //this.$refs.tree.setChecked([first], true)
                //this.$refs.tree.setCheckedKeys([0], true)
                ////console.log(this.$refs.tree.store._getAllNodes(), 9090);
                //this.checkedLoops = [first]
                //console.log([first], 9090)
            },
            unique(arr) {
                return Array.from(new Set(arr));
            },
            // getLoopStatus(tpl) {
            //   return this.$store.getters.mqttVal(tpl.subLoopUrl + "/SwitchOn");
            // },
            async getBreakerList(aid) {
                if (aid < 0) {
                    return;
                }
                let response = await breakerList(this.allArea[aid].areaId);
                this.breakerList = response.data.data.list || [];
            },
            async getProtect(aid) {
                if (aid < 0) {
                    return;
                }
                let response = await Arcprotection(this.allArea[aid].areaId);
                this.protect = response.data.data.list || [];
            },
            async getPower(aid) {
                //谐波分析
                if (aid < 0) {
                    return;
                }
                let response = await harmonicAnalysis(
                    this.$store.state.project.currentProject.projectId
                );
                this.Power = response.data.data.deviceLoops || [];
            },
            async getTransformerList(aid) {
                if (aid < 0) {
                    return;
                }
                let response = await transformerList(this.allArea[aid].areaId);
                // console.log('========================>', response);
                this.transformerList = response.data.data.list || [];
            },
            renderContent(createElement, {
                node,
                data,
                store
            }) {
                return createElement(
                    "div", {
                        class: {
                            "row-center": true,
                            custom: true,
                        },
                        style: {
                            justifyContent: "space-between",
                            width: "100%",
                            paddingRight: "30rem",
                        },
                    },
                    [
                        createElement("span", {
                            domProps: {
                                innerHTML: data.label,
                            },
                        }),
                        createElement("span", {
                            domProps: {
                                innerHTML: data.type,
                            },
                        }),
                    ]
                );
            },
            currentChange(data, node, n) {
                this.selectedNodes = node.checkedNodes;
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l ? l.loopName.indexOf(this.filterText) !== -1 : false;
                });
            },
            //点击传参
            //侧边栏子回路点击之后传参
            nodeClick(data) {
                this.$store.commit("ArcprotectStatus", data);
                this.currentLoop = data;
            },
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },

            areaFilter(item) {
                if (!this.areaFilterText) {
                    return true;
                }
                return item.areaName.indexOf(this.areaFilterText) !== -1;
            },
            updateMqtt(n, o) {
                if (o && o.subLoopUrl) {
                    unsubscribe([o.subLoopUrl]);
                    alarmUnsubscribe([o]);
                }
                if (n && n.subLoopUrl) {
                    subscribe([n.subLoopUrl]);
                    alarmSubscribe([n]);
                }
            },
        },
        watch: {
            areaFilterText(n, o) {
                if (!n) {
                    this.showAreaNumber = this.allArea.length;
                } else {
                    this.showAreaNumber = this.allArea.filter((area) => {
                        return area.areaName.indexOf(n) !== -1;
                    }).length;
                }
            },
            tag(n, o) {
                this.checkedLoops = [];
                this.$refs.tree.setCheckedNodes([]);
            },
            routeName() {
                this.reFresh = false;
                this.$nextTick(() => {
                    this.reFresh = true;
                });
                this.loopInit();
                this.selectedNodes = [];
                this.filterText = ""
            },
            master(n, o) {
                this.updateMqtt(n, o);
            },
            currentLoop(n, o) {
                this.updateMqtt(n, o);
            },
            details(n) {
                this.getTransformerList(n);
                this.getBreakerList(n);
                this.getProtect(n);
                this.getPower(n);
                GET_AREA_LOOPS(this.allArea[n].areaId).then((res) => {
                    // console.log(res.data.data.loops, "========>");
                    this.loops = res.data.data.loops.filter(
                        (item) => !~item.loopName.indexOf("变压器设备")
                    ); // 临时过滤虚拟回路的方案
                    // console.log(this.loops, "========>");
                });
                this.filterText = "";
            },
            filterText(val) {
                this.$refs.tree.filter(val);
                this.checkedLoops = this.selectedNodes.filter((l) => {
                    return l.loopName.indexOf(val) !== -1;
                });
            },
        },
    };
</script>

<style scoped lang="less">
    .area-list {
        position: absolute;
        left: 0;
        top: 0;
        .w(504);
        .h(520);
        background-color: #fff;
        box-shadow: 0 4rem 40px 0 rgba(0, 43, 102, 0.28);
        padding: 24rem 16rem;
        z-index: 999;

        .areas {
            margin-top: 24rem;
            min-height: 200rem;

            .row {
                margin-bottom: 24rem;

                p {
                    font-size: 16rem;
                    color: #333333;
                    font-weight: 400;
                    .w(400);
                }

                img {
                    .w(48);
                    .h(48);
                    margin-right: 13rem;
                    margin-left: 8rem;
                }
            }
        }

        .search {
            .h(48);
            width: 100%;
            overflow: hidden;
            border-radius: 24rem;
            border: 1px solid rgba(0, 0, 0, 0.15);
            position: relative;

            input {
                width: 100%;
                height: 100%;
                padding: 0 20rem;
                font-size: 16rem;
                color: #000000;
                font-weight: 400;
                line-height: 48rem;
            }

            img {
                position: absolute;
                right: 16rem;
                top: 15rem;
                z-index: 99;
            }
        }
    }

    #power-data {
        justify-content: space-between;

        .h(968);

        >.data {
            position: relative;
            .w(1265);
            height: 100%;
        }

        .left {
            height: 100%;
            justify-content: flex-start !important;
            background-color: #fff;
            .w(325);

            .list {
                padding: 24rem 0rem 24rem 24rem;
                overflow: hidden;
                width: 100%;

                .search {
                    display: flex;
                    flex-flow: row nowrap;
                    justify-content: center;
                    align-items: center;
                }

                input {
                    border: none;
                    outline: none;
                    font-size: 18rem;
                    color: #666666;
                    .w(262);
                }

                .tree {
                    margin-top: 35rem;

                    height: 750 / 1080 * 100vh;
                    overflow: auto;

                    &::-webkit-scrollbar {
                        width: 0 !important;
                    }

                    /deep/ .el-scrollbar__wrap {
                        overflow-x: hidden;
                        height: calc(100% - 10px);
                    }

                    .el-tree {
                        padding-right: 24rem;
                    }
                }
            }
        }
    }

    .power-data-item {
        display: flex;
        justify-content: space-between;
        position: relative;
        width: 100%;

        .power-data-item1 {
            position: absolute;
            right: 0;
        }

        .power-data-item-label {
            font-size: 18rem;
            font-weight: 400;
            color: #666666;
            width: 80%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
        }

        .power-data-item-label.checked {
            font-weight: bold;
            color: #0d94ff;
        }

        .power-data-item-open {
            color: #68d86a;
            position: absolute;
            right: 0;
        }

        .power-data-item-close {
            position: absolute;
            right: 0;
            color: #fd4238;
        }
    }

    .no-found-data-warpper {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #fff;
    }

    //弹出框样式
    .area_popper {
        background-color: #3d4451 !important;
        border-radius: 6px !important;
        opacity: 0.9 !important;
        font-size: 12px !important;
        color: #ffffff !important;
        padding: 0 !important;
        transform: translateY(12px);
    }

    .showText {
        margin: 8px;
    }

    &::-webkit-scrollbar {
        width: 0 !important;
    }

    /deep/ .el-scrollbar__wrap {
        overflow-x: hidden;
        height: calc(100% - 10px);
    }

    .el-tree {
        padding-right: 33rem;
    }
</style>